export { DMS_MODULE } from '@/modules/ciselnik/constants';
export const CRUMB_LABEL_KEY = 'edtFaktProfilHodSzbNahr';
export const NAME = 'NahradniHodinovaSazba';
